import { Sport } from "../../sport-slice";
import { PlayPayloadBase, PlayPayloadProperties } from "./play-payload-generic";

export enum BasketballDrawingArea {
  FRONTCOURT = 1,
  BACKCOURT = 2,
  FULLCOURT = 3,
}

export interface BasketballPlayPayloadProperties {
  outOfBounds: string;
}

export interface PlayPayloadBasketball extends PlayPayloadBase {
  sport: Sport.BASKETBALL;
  drawingArea?: BasketballDrawingArea;
  properties?: Partial<PlayPayloadProperties> & BasketballPlayPayloadProperties;
}
